import OurCompaniesPublication from "./OurCompaniesPublication";

export default OurCompaniesPublication;
